export default {
  title: '提现记录',
  body: {
    cmpt: {
      type: 'CWithdrawRecordList'
    }
  }
}
